import 'es6-promise-promise';
import './Auth/authenticate-component';
import './Cart/cart';
import './Search/navigation-search';
import './Search/search-focus';
import './V3/site-selector-v3.expand';
import './V3/site-selector-v3.persistence';
import './V3/top-menu-v3';
import './V3/footer-v3';
